/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const chartLoaderStyles = cssMap({
	skeletonContainer: {
		width: '100%',
		height: '100%',
		minHeight: '200px',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.150'),
	},
	barsContainer: {
		flexGrow: 1,
		minHeight: '0px',
		height: '0px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-end',
		gap: token('space.100'),
	},
});

interface ChartLoaderProps {
	testId?: string;
	interactionName?: string;
}

// Loading component for chart Suspense fallback
// Displays a shimmer skeleton mimicking a chart layout
export const ChartLoader = ({ testId, interactionName }: ChartLoaderProps): JSX.Element => {
	const containerProps = testId ? { testId: `${testId}-loading` } : {};
	const ufoName = interactionName || 'rovo-viz-chart-bundle-load';

	return (
		<UFOLoadHold name={ufoName}>
			<Box xcss={chartLoaderStyles.skeletonContainer} {...containerProps}>
				<Stack space="space.100">
					<Skeleton width="55%" height="16px" borderRadius={token('radius.small')} isShimmering />
					<Skeleton width="35%" height="12px" borderRadius={token('radius.small')} isShimmering />
				</Stack>
				<Box xcss={chartLoaderStyles.barsContainer}>
					<Skeleton width="100%" height="15%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="40%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="60%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="35%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="80%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="50%" isShimmering borderRadius={token('radius.small')} />
					<Skeleton width="100%" height="25%" isShimmering borderRadius={token('radius.small')} />
				</Box>
			</Box>
		</UFOLoadHold>
	);
};

export default ChartLoader;
